export default {
  getAccountById: (state) => (id) => {
    return state.n2Accounts.accounts.find((account) => account.id === id);
  },
  getN1AccountById: (state) => (id) => {
    return state.n1Accounts.accounts.find((account) => account.id === id);
  },
  isFeatureFlagEnabled: (state) => (featureFlag) => {
    return state.featureFlags[featureFlag] === true;
  },
  getVirtualDeviceListSearchItems: (state) => {
    return state.pageFilters?.VirtualDevice?.list?.searchDetails || [];
  },
  getVirtualDeviceListSearchOperator: (state) => {
    return state.pageFilters?.VirtualDevice?.list?.searchOperator || 'AND';
  },
};
